<template>
    <!-- The Kayıp Güç methods as cards, as the design draws them. "Measured temperature" is
         offered only up to 630 A. The page decides what a choice does. -->
    <div class="method-cards" role="tablist">
        <button v-for="method in methods"
                :key="method.index"
                type="button"
                role="tab"
                class="method-card"
                :class="{ 'is-active': method.index === active }"
                :aria-selected="method.index === active ? 'true' : 'false'"
                @click="$emit('select', method.index)">
            <img :src="method.icon" alt="" />
            <span>{{ method.label }}</span>
        </button>
    </div>
</template>

<script>
    export default {
        name: 'CalcMethodCards',
        props: {
            // 0 known total power, 1 measured temperature, 2 the calculation tool
            active: { type: Number, default: 0 },
            showMeasured: { type: Boolean, default: false }
        },
        computed: {
            methods() {
                const c = this.$lang.Calculation;
                const label = (...parts) => parts.filter((p) => p).join(' ');
                const list = [{ index: 0, icon: '/img/icon_1.png', label: label(c.InnerTitle_1, c.InnerTitle_2, c.InnerTitle_3) }];
                if (this.showMeasured) {
                    list.push({ index: 1, icon: '/img/icon_2.png', label: label(c.InnerTitle_4, c.InnerTitle_5, c.InnerTitle_8) });
                }
                list.push({ index: 2, icon: '/img/icon_3.png', label: label(c.InnerTitle_6, c.InnerTitle_7, c.InnerTitle_8) });
                return list;
            }
        }
    };
</script>
